<script setup>
import { toRefs } from 'vue';
import { useAuth } from '../../../auth';
// `route` `user` and `signOut` all are reactive.
const { user } = toRefs(useAuth());
</script>
<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1"
          :items="user.attributes['custom:role'] == 'Admin' ? items : null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter; this.search = ''"
                    :class="{ setclose: filter }">
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg" alt="img" /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input type="search" v-model="search" class="form-control form-control-sm" placeholder="Search..."
                        aria-controls="DataTables_Table_0" @change="searching" />
                    </label>
                  </div>
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <a data-bs-toggle="tooltip" data-bs-placement="top" title="Downoad excel" @click="exportToCSV">
                  <img src="../../../assets/img/icons/excel.svg" alt="img" class="excel-icon" />
                </a>
                <div class="stock-status-select" style="margin-left: 15px;">
                  <model-list-select :list="StockStatusList" v-model="selectedCategory" option-value="value"
                    option-text="text" placeholder="Select stock status">
                  </model-list-select>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <a-table :columns="columns" :data-source="filteredItems">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'itemid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.itemname }}</a>
                    </div>
                  </template>
                  <template v-else-if="column.key === 'action' && user.attributes['custom:role'] == 'Admin'">
                    <a class="me-3" @click="editproduct(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a class="confirm-text" href="javascript:void(0);" @click="showAlert(record.itemid)">
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ModelListSelect } from "vue-search-select"
const columns = [
  {
    sorter: true,
  },
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "itemcategory",
    sorter: {
      compare: (a, b) => {
        a = a.itemcategory.toLowerCase();
        b = b.itemcategory.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Unit",
    dataIndex: "unit",
    sorter: {
      compare: (a, b) => {
        a = a.unit.toLowerCase();
        b = b.unit.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Unit Price",
    dataIndex: "unitprice",
    sorter: {
      compare: (a, b) => {
        a = a.unitprice;
        b = b.unitprice;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Quantity",
    dataIndex: "available",
    sorter: {
      compare: (a, b) => {
        a = a.available;
        b = b.available;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Threshold",
    dataIndex: "threshold",
    sorter: {
      compare: (a, b) => {
        a = a.threshold;
        b = b.threshold;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Item List",
      title1: "Manage your items",
      items: [
        {
          text: "Add New Item",
          addname: "/addproduct",
        },
      ],
      selectedCategory: 'all',
      StockStatusList: [
        { value: 'all', text: 'All Stock' },
        { value: 'low_stock', text: 'Low Stock' },
        { value: 'out_of_stock', text: 'Out of Stock' }
      ],
      Product: ["Choose Product", "Macbook pro", "Orange"],
      Category: ["Choose Sub Category", "Computer"],
      Choose: ["Choose Category", "Computers", "Fruits"],
      Brand: ["Brand", "N/D"],
      Price: ["Price", "150.00"],
      data: null,
      nostocklist: [],
      lowstocklist: [],
      stockdata: [],
      columns,
    };
  },
  methods: {
    exportToCSV() {
      const items = this.filteredItems;
      const headers = ['Item Id', 'Item Name', 'Item Description', 'Item Category', 'Unit', 'Unit Price', 'Available', 'Threshold'];

      const csvContent = [
        headers.join(','),
        ...items.map(item => [
          item.itemid,
          item.itemname,  // No quotes
          item.itemdescription,  // No quotes
          item.itemcategory,  // No quotes
          item.unit,
          item.unitprice,
          item.available,
          item.threshold
        ].join(','))
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'items.csv';
      link.click();
    },
    handleKeydown(event) {
      if (this.$route.path === '/productlist' && event.ctrlKey && (event.key === 'm') || event.ctrlKey && (event.key === 'M')) {
        event.preventDefault();

        this.$router.push('/addproduct');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete('/v1/items/' + id)
            .then(response => {
              Swal.fire("Deleted!", "Your file has been deleted.");
              var index = this.data.findIndex(function (o) {
                return o.itemid === id;
              })
              if (index !== -1) this.data.splice(index, 1);
            })
            .catch(error => {
              console.log(error)
              Swal.fire(error.response.data.detail);
            });
        }
      });
    },
    editproduct(product) {
      this.$router.push({ path: '/editproduct', query: { id: product.itemid } });
    },
    async getItems() {
      axios
        .get('/v1/items')
        .then(response => {
          this.data = response.data;
          this.lowstocklist = this.data.filter(item => item.available <= item.threshold && item.available > 0);
          this.nostocklist = this.data.filter(item => item.available === 0);
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        });
    },
  },
  computed: {
    // coming
    filteredItems() {
      let items = [];
      if (this.selectedCategory === 'low_stock') {
        items = this.lowstocklist;
      } else if (this.selectedCategory === 'out_of_stock') {
        items = this.nostocklist;
      } else {
        items = this.data;
      }
      return this.data ? items.filter(item => {
        return !this.search ||
          item['itemname'].toString().toLowerCase().includes(this.search.toLowerCase());
      }) : [];

    },
  },
  beforeMount() {
    const category = this.$route.query.category;
    if (category) {
      this.selectedCategory = category;
    }
    this.getItems();
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  name: "productlist",
};
</script>
<style>
.ant-tooltip {
  display: none !important;
}

@media (max-width: 576px) {
  .stock-status-select {
    margin-top: 10px;
  }
}
.excel-icon {
  width: 25px;
  height: 25px;
}

</style>
